const ITEM_MAX_PACKAGE_VALUE = 5000;

export default ITEM_MAX_PACKAGE_VALUE;
